var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9823_16432)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9 8.41772C7.34315 8.41772 6 7.07458 6 5.41772C6 3.76087 7.34315 2.41772 9 2.41772C10.6569 2.41772 12 3.76087 12 5.41772C12 7.07458 10.6569 8.41772 9 8.41772Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25049 15.3171C2.54119 11.7376 5.44643 9.91772 8.98751 9.91772C12.5784 9.91772 15.5287 11.6376 15.7484 15.3177C15.7572 15.4643 15.7484 15.9177 15.185 15.9177C12.4058 15.9177 8.27604 15.9177 2.79563 15.9177C2.60753 15.9177 2.23465 15.5121 2.25049 15.3171Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9823_16432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.167725)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserH);
export default __webpack_public_path__ + "static/media/user_h.d0bd59cbd127ae4edcaa7d198e1d32e0.svg";
export { ForwardRef as ReactComponent };